@let routeFromTrainingsToEdit = routeFromTrainingsToEdit$ | async;
<div class="info-section">
  <span class="info-section__header">
    {{ 'general.staff' | translate }}
  </span>
  <div>
    @for (userId of usersFromTrainingsToEdit$ | async; track userId) {
      <nz-tag>{{ userId | userName | async }}</nz-tag>
    }
  </div>
</div>
@if ((qualificationsFromTrainingsToEdit$ | async).length > 0) {
  <div class="info-section">
    <span class="info-section__header">
      {{ 'general.qualifications' | translate }}
    </span>
    <div>
      @for (
        qualificationId of qualificationsFromTrainingsToEdit$ | async;
        track qualificationId
      ) {
        <nz-tag>{{ qualificationId | qualificationV2Name | async }}</nz-tag>
      }
    </div>
  </div>
}
@if (routeFromTrainingsToEdit && routeFromTrainingsToEdit.length > 0) {
  <div class="info-section">
    <span class="info-section__header">
      {{ 'general.route_knowledge' | translate }}
    </span>
    <div>
      @for (
        route of routeFromTrainingsToEdit$ | async;
        track route.locationCode
      ) {
        <nz-tag
          nz-tooltip
          [nzTooltipTitle]="getRouteTooltipTitle(route)"
          class="cursor-pointer"
        >
          {{ route.locationCode }}
        </nz-tag>
      }
    </div>
  </div>
}
<div class="info-section">
  <span class="info-section__header">
    {{ 'page.training-qualifications.provider' | translate }}
  </span>
  <div>
    @for (provider of providersFromTrainingsToEdit$ | async; track provider) {
      <wilson-qualification-training-provider-tag
        [provider]="provider"
        customClass="rounded-1"
      />
    }
  </div>
</div>
